import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { MobileCallBar } from "@/components/site/MobileCallBar";
import Home from "@/pages/Home";
import HotWaterPage from "@/pages/HotWaterPage";
import VentilationPage from "@/pages/VentilationPage";
import AboutPage from "@/pages/AboutPage";
import DownloadsPage from "@/pages/DownloadsPage";
import NccPage from "@/pages/NccPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import WarrantyRegistration from "@/pages/WarrantyRegistration";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => (lenis ? lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView()), 100);
        return;
      }
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App sa-noise bg-[#010101] relative">
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0d0d0d", border: "1px solid #262626", color: "#fff" } }} />
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <MobileCallBar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solar-hot-water" element={<HotWaterPage />} />
            <Route path="/solar-roof-ventilation" element={<VentilationPage />} />
            <Route path="/ncc-compliance" element={<NccPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/downloads" element={<DownloadsPage />} />
            <Route path="/warranty-registration" element={<WarrantyRegistration />} />
          </Routes>
        </main>
      </BrowserRouter>
    </div>
  );
}

export default App;
